var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('abby-media-container',{attrs:{"sourceId":_vm.sourceId_SharedLibrary,"toolbarColor":_vm.toolbarColor,"toolbarColorDark":_vm.toolbarColorDark}})}
var staticRenderFns = []

export { render, staticRenderFns }